import { lazy } from 'react';
import { APP_PATHS } from '../paths';
import { RouteConfig } from '../types';

const Home = lazy(() => import('../../views/home/Home'));
const JobCategories = lazy(() => import('../../views/home/JobCategories'));
const ChooseCompany = lazy(() => import('../../views/home/ChooseCompany'));
const ConfirmInterview = lazy(
  () => import('../../views/home/ConfirmInterview')
);
const StartAnswering = lazy(
  () => import('../../views/home/start_answering/StartAnswering')
);
const Feedback = lazy(() => import('../../views/home/feedback/Feedback'));
const SelectQuestionType = lazy(
  () => import('../../views/home/SelectQuestionType')
);
const Summary = lazy(() => import('../../views/home/Summary'));
const Resources = lazy(() => import('../../views/home/Resources'));
const AnswerFeedback = lazy(() => import('../../views/home/AnswerFeedback'));
const Analytics = lazy(() => import('../../views/home/Analytics'));
const Account = lazy(() => import('../../views/home/account/Account'));
const Checkout = lazy(() => import('../../views/home/Checkout'));
const InterviewAcademyHome = lazy(
  () => import('../../views/home/InterviewAcademy/InterviewAcademyHome')
);
const InterviewAcademyLevel = lazy(
  () => import('../../views/home/InterviewAcademy/InterviewAcademyLevel')
);
const CustomInterview = lazy(() => import('../../views/home/CustomInterview'));

export const mainRoutes: RouteConfig[] = [
  {
    path: APP_PATHS.home,
    element: <Home />,
  },
  {
    path: APP_PATHS.jobCategories,
    element: <JobCategories />,
  },
  {
    path: APP_PATHS.chooseCompany,
    element: <ChooseCompany />,
  },
  {
    path: APP_PATHS.confirmInterview,
    element: <ConfirmInterview />,
    isPrivate: true,
  },
  {
    path: APP_PATHS.startAnswering,
    element: <StartAnswering />,
    isPrivate: true,
  },
  {
    path: APP_PATHS.feedback,
    element: <Feedback />,
    isPrivate: true,
  },
  {
    path: APP_PATHS.selectQuestionType,
    element: <SelectQuestionType />,
    isPrivate: true,
  },
  {
    path: APP_PATHS.summary,
    element: <Summary />,
    isPrivate: true,
  },
  {
    path: APP_PATHS.resources,
    element: <Resources />,
    isPrivate: true,
  },
  {
    path: `${APP_PATHS.resources}/:pageId`,
    element: <Resources />,
    isPrivate: true,
  },
  {
    path: APP_PATHS.answerFeedback,
    element: <AnswerFeedback />,
    isPrivate: true,
  },
  {
    path: APP_PATHS.analytics,
    element: <Analytics />,
    isPrivate: true,
  },
  {
    path: APP_PATHS.account,
    element: <Account />,
    isPrivate: true,
  },
  {
    path: APP_PATHS.checkout,
    element: <Checkout />,
    isPrivate: true,
  },
  {
    path: APP_PATHS.interviewAcademyHome,
    element: <InterviewAcademyHome />,
    isPrivate: true,
  },
  {
    path: APP_PATHS.interviewAcademyLevel,
    element: <InterviewAcademyLevel />,
    isPrivate: true,
  },
  {
    path: APP_PATHS.customInterview,
    element: <CustomInterview />,
    isPrivate: true,
  },
];
